import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProjectCloudResourcesSection } from "./ProjectCloudResourcesSection";
import { StreamFeedsAndSignals } from "./StreamFeedsAndSignals";
import { StreamTakerList } from "./StreamTakerList";

interface ProjectStreamsTabProps {
  projectId: string;
}

export const ProjectStreamsTab = ({ projectId }: ProjectStreamsTabProps) => {
  return (
    <Tabs defaultValue="feeds" className="space-y-4">
      <TabsList>
        <TabsTrigger value="feeds">Feeds &amp; Signals</TabsTrigger>
        <TabsTrigger value="cloud">Cloud Resources</TabsTrigger>
      </TabsList>

      <TabsContent value="feeds" className="space-y-8">
        <StreamFeedsAndSignals projectId={projectId} />
        <StreamTakerList projectId={projectId} />
      </TabsContent>

      <TabsContent value="cloud">
        <ProjectCloudResourcesSection projectId={projectId} />
      </TabsContent>
    </Tabs>
  );
};
